import { createScheduledEnrichmentStore } from './create-scheduled-enrichment-store';

/**
 * Persisted store for a single Google Ads (GMC) scheduled enrichment session.
 * A dedicated `scheduled-google-enrichment` localStorage key keeps it isolated
 * from the Meta session so both flows can hold independent in-flight state.
 */
export const useScheduledGoogleStore = createScheduledEnrichmentStore(
  'scheduled-google-enrichment',
);
